import { gql } from '@apollo/client';
import { GQL_TAG_FRAGMENT } from './fragments';

export const GQL_ALTER_TAGS = gql`
  mutation AlterTags($input: RecordablesAlterTagsInput!) {
    recordablesAlterTags(input: $input) {
      recordables {
        __typename
        ... on Node {
          id
        }
        ... on Photo {
          databaseId
        }
        ... on RecordableInterface {
          tagsCount
          tags(last: 100) {
            __typename
            edges {
              node {
                ...TagFragment
              }
            }
          }
        }
      }
      errors {
        message
        path
        error
      }
    }
  }

  ${GQL_TAG_FRAGMENT}
`;
